export default __webpack_public_path__ + "static/subset-UniNeueBold-0583225a233ae178041bf2a56baa39bd.woff2";